/**
 * Purpose: This middleware builds and sets the latest offer payload object in memory. Add redux actions to the validActions array when those actions should update the payload.
 */
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { type ReduxNext } from '@makemydeal/dr-shared-store';
import { showFailedUpdateOfferModal } from '../actions/failedOfferUpdateActionCreators';

import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import * as offerInfoSelectors from '../selectors/offerInfoSelectors';
import { REQUEST_CANCEL_ORDER_FAILURE, REQUEST_CANCEL_ORDER_SUCCESS } from '../types/orders';
import { createLoggingContextSelector } from '../selectors/loggingContextSelector';

export const middleware = (store: any) => (next: ReduxNext) => (action: AnyFSA) => {
    next(action);

    const state = store.getState();

    switch (action.type) {
        case REQUEST_CANCEL_ORDER_SUCCESS: {
            if (typeof action.meta?.callBack === 'function') {
                typeof action.meta.callBack();
            }
            break;
        }

        case REQUEST_CANCEL_ORDER_FAILURE: {
            // The modal popup box response
            store.dispatch(showFailedUpdateOfferModal());

            const isEcommercePendingCancellation = offerInfoSelectors.getEcommercePendingCancellationStatus(state);

            if (isEcommercePendingCancellation) {
                logNewRelicPageAction('MV:Order - Cancelling and Saving Failed', {
                    ...createLoggingContextSelector(state),
                    isCancellingAndSavingFailed: true,
                    action
                });
            }
            break;
        }

        default: {
            break;
        }
    }
};
